
import { useNavigate, useParams, useLocation } from "react-router-dom"

import { useDispatch } from "react-redux";
import { visualizerActions } from '../../store';

import { loadShareLink } from "../../Helpers/ShareHelper";

export default function LoadingPage(){

    const urlParams = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    if(urlParams.code === "UPLOAD"){
        const backup = JSON.parse(localStorage.getItem("VIZ_BACKUP"));
        if(backup) {
            dispatch(visualizerActions.loadBackup(backup));
        }

        // Extract spec from the wildcard path (everything after /shared/UPLOAD/)
        const pathAfterCode = location.pathname.split('/shared/UPLOAD/')[1];
        const decodedSpec = decodeURIComponent(pathAfterCode || '');

        var uploadImages = []; // JSON.parse(localStorage.getItem("UPLOAD_SPECS"));

        if(uploadImages === null) uploadImages = [];

        if(uploadImages.indexOf(decodedSpec) === -1){
            uploadImages.push(decodedSpec);
        }

        localStorage.setItem("UPLOAD_SPECS",JSON.stringify(uploadImages));
        

        setTimeout(() => {
        navigate(`/visualizer/spec/${encodeURIComponent(decodedSpec)}/sel/-1`);
        }, 1000);
    }
    else{
        loadShareLink(urlParams.code).then(data => {
            const shareData = JSON.parse(data.data1);
    
            dispatch(visualizerActions.loadBackup(shareData.backup));
    
            navigate(`/visualizer`);
        })
    }

    // useEffect(() => {
        
        

    // }, []);

    return (
    <section>
        Redirecting...
    </section>);
}